import { BuyCreditsModal } from "@/components/credits/BuyCreditsModal";
import { createFileRoute, redirect } from "@tanstack/react-router";
import z from "zod";

const unsafeNavigateOptionsSchema = z.object({
  to: z.string(),
  search: z.record(z.string(), z.any()).optional(),
  state: z.record(z.string(), z.any()).optional(),
});

const historyStateSchema = z
  .object({
    neededCredits: z.number(),
    continueNavigateOptions: unsafeNavigateOptionsSchema,
    skipNavigateOptions: unsafeNavigateOptionsSchema,
  })
  .optional()
  .catch(undefined);

const parseHistoryState = (historyState: z.infer<typeof historyStateSchema>) =>
  historyStateSchema.parse(historyState);

export const Route = createFileRoute(
  "/_dashboard/campaigns/$id/(edit)/delivery/setup/buy-credits",
)({
  staticData: {
    crumb: "Tilkøb credits",
    meta: {
      title: "Tilkøb credits",
    },
  },
  beforeLoad: ({ location }) => {
    const historyState = parseHistoryState(
      location.state.routeStates?.[Route.id],
    );

    if (!historyState)
      throw redirect({
        from: Route.to,
        to: "..",
        replace: true,
      });

    return {
      parseHistoryState,
      useHistoryState: () => historyState,
    };
  },
  loader: () => ({
    showCampaignSetupSubStepper: false,
    showCampaignSetupBottomBar: false,
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const { useHistoryState } = Route.useRouteContext();
  const navigate = Route.useNavigate();

  const historyState = useHistoryState();

  const goBack = async (shouldContinue: boolean) => {
    await navigate(
      shouldContinue
        ? historyState.continueNavigateOptions
        : historyState.skipNavigateOptions,
    );
  };

  return (
    <div className="-mt-8 flex flex-col pt-4 xl:-mt-14 xl:pt-7">
      <BuyCreditsModal
        neededCredits={historyState.neededCredits}
        onClose={() => goBack(false)}
        onSuccess={() => goBack(true)}
        onSkip={() => goBack(true)}
      />
    </div>
  );
}
